import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "link-button-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "link-button-arrow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-arrow-chevron-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_k_button, {
      disabled: _ctx.disabled,
      onClick: _ctx.onClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.caption) + " ", 1),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}